export default class ChangeLanguageSwitcherContent {
    private languageWrapper: HTMLElement | null;

    constructor(private readonly section) {
        this.languageWrapper = this.section.querySelector("[js-language-switcher]");
    }

    public init = async () => {
        if (!this.languageWrapper) return;

        this.changeSwitcherContent();
    };

    private changeSwitcherContent = () => {
        const switcher = this.languageWrapper?.querySelector(".wpml-ls-native") as HTMLElement,
            currentLangPrefix = switcher?.getAttribute("lang")?.toUpperCase() as string;

        switcher.classList.add("switcher-visible");

        if (!switcher) return;

        switcher.textContent = currentLangPrefix;
    };
}
